import { inject, observer } from 'mobx-react';

import Icons from 'bz-core-controls/icons';
import { computed } from 'mobx';
import React from 'react';
import Action from '../action-base';

@inject('vm', 'clinicalStore')
@observer
class ErrorActions extends React.Component {
  render() {
    if (!this.show) return null;

    return <Action label="Reload" icon={Icons.taskReset} onClick={this.onClick.bind(this)} />;
  }

  @computed
  get show() {
    return this.props.vm.status === 'error';
  }

  onClick() {
    this.props.clinicalStore.prontoStore.onLoad(true);
  }
}

export default ErrorActions;
